<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
  <div class="btn-toolbar mb-2 mb-md-0">
    <a routerLink="/roles/create" class="btn btn-sm btn-outline-secondary">Add</a>
  </div>
</div>

<div class="table-responsive">
  <table class="table table-lg">
    <thead>
      <tr>
        <th>#</th>
        <th>Name</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let role of roles">
        <td>{{role.id}}</td>
        <td>{{role.name}}</td>
        
        <td class="text-nowrap">

          <a href="javascript:void(0)" [routerLink]="['/roles', role.id, 'edit']"  class="btn  btn-outline-secondary mr-2"><i class="fa fa-pencil "></i></a>

          <a href="javascript:void(0)" (click)="delete(role.id)"  class="btn  btn-outline-danger" ><i class="fa fa-trash-o "></i></a>
        
            <!-- <div class="btn-group mr-2" >
              <a href="javascript:void(0)" [routerLink]="['/roles', role.id, 'edit']" class="btn btn-sm btn-outline-secondary">Edit</a>
              <a href="javascript:void(0)" (click)="delete(role.id)" class="btn btn-sm btn-outline-secondary">Delete</a>
            </div> -->
        </td>
      </tr>
    </tbody>
  </table>
</div>
